/**
 * Session Management Page Styles
 * Carbon Design System compliant
 */
.loadingContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.pageHeader {
  color: var(--cds-text-secondary);
}

.notificationMargin {
  margin-top: var(--cds-spacing-05);
}

.logoutAllButton {
  margin-top: var(--cds-spacing-06);
}

.sessionsTable {
  margin-top: var(--cds-spacing-06);
}

.securityInfo {
  margin-top: var(--cds-spacing-07);
}

.deviceInfo {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-03);
}
.deviceInfo .deviceName {
  font-weight: 500;
}
.deviceInfo .currentSessionTag {
  margin-top: 4px;
}

.locationInfo {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-02);
}
.locationInfo .locationIcon {
  color: var(--cds-icon-secondary);
}

.lastActiveInfo {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-02);
}
.lastActiveInfo .timeIcon {
  color: var(--cds-icon-secondary);
}

.activeLabel {
  color: var(--cds-text-disabled);
  font-size: 0.875rem;
}

.sessionDetailsCard {
  padding: var(--cds-spacing-04);
  background-color: var(--cds-layer-01);
  border-left: 4px solid var(--cds-border-interactive);
}
.sessionDetailsCard .detailRow {
  margin-bottom: var(--cds-spacing-02);
}
.sessionDetailsCard .detailRow:last-child {
  margin-bottom: 0;
}

.revokeAllCard {
  padding: var(--cds-spacing-04);
  background-color: var(--cds-layer-01);
  border-left: 4px solid var(--cds-support-error);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */